export const SELECT_TOOL_ID = "select";

export const selectToolConfig = {
  id: SELECT_TOOL_ID,
  usesPreview: false,
  cursor: "default",
  onStart: () => true,
  onMove: () => {},
  onEnd: () => {},
};

const SelectToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === SELECT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(SELECT_TOOL_ID)}
      title="Select"
      aria-label="Select"
    >
      🖱
    </button>
  );
};

export default SelectToolButton;